<span>
  {{ 'AUTOMATIONS.EDITOR.TRIGGERS.CUSTOMER_ASKED_QUESTION.ASKED_QUESTION_DESCRIPTION' | translate }}
</span>
